import { v4 as uuid } from 'uuid';
import {
  topicInformation,
  UserSettings,
  Topic,
} from '@jupiterone/notification-types';
import { generateMockChannelConfiguration } from 'navbar/src/jupiterAccountSettings/AccountSettings/Notifications/graphql/generateMockChannelConfiguration';

/* Generate Notification settings mock dynamically based on notification-types */
export const generateMockNotificationSettings = () => {
  return Object.keys(topicInformation).reduce(
    (res, topic) => {
      const { category } = topicInformation[topic as Topic];
      res[category] = {
        ...res[category],
        [topic]: generateMockChannelConfiguration(),
      } as any;
      return res;
    },
    { _id: uuid() } as UserSettings
  );
};
